import { Box, Typography } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const CostLoggingTemplateForm = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
        padding: 4,
      }}
    >
      <Typography
        variant="body1"
        sx={{
          color: abyssColors.primary[400],
          fontSize: '1.4rem',
          fontStyle: 'italic',
        }}
      >
        Cost Logging will be implemented later
      </Typography>
    </Box>
  );
};
